import { render, staticRenderFns } from "./ClauseSelector.vue?vue&type=template&id=78b31244&scoped=true&"
import script from "./ClauseSelector.vue?vue&type=script&lang=js&"
export * from "./ClauseSelector.vue?vue&type=script&lang=js&"
import style0 from "./ClauseSelector.vue?vue&type=style&index=0&id=78b31244&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b31244",
  null
  
)

export default component.exports